// The same checks as checked() in platform/api/app/portal_contact.py.
export const PHONE_MAX = 30;
export const EMAIL_MAX = 254;
const PHONE_DIGITS = 7;

export type ContactProblem = { field: "phone" | "email"; text: string };

/** The problem of the portal contact form, or null. Both fields can be empty. */
export function contactProblem(phone: string, email: string): ContactProblem | null {
  const p = phone.trim();
  const e = email.trim();
  if (p.length > PHONE_MAX) return { field: "phone", text: `The phone number can have ${PHONE_MAX} characters at most.` };
  const digits = (p.match(/[0-9]/g) ?? []).length;
  if (p && (!/^[0-9+().\- ]+$/.test(p) || digits < PHONE_DIGITS)) return { field: "phone", text: "Enter a phone number with digits, for example +1 555 010 0199." };
  if (e.length > EMAIL_MAX) return { field: "email", text: "The email address is too long." };
  if (e && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e)) return { field: "email", text: "Enter an email address, for example service@example.com." };
  return null;
}

/** The words under the form: what the customers see now. */
export function contactShownText(phone: string, email: string): string {
  const parts = [phone.trim(), email.trim()].filter(Boolean);
  return parts.length
    ? `Your customers see ${parts.join(" and ")} under "Who to contact" in the customer portal.`
    : 'Your customers see no phone or email: "Who to contact" tells them to contact you.';
}
